"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UrlApi = exports.UrlApiMetaCommand = exports.UrlRequestMetadataParameterNames = void 0;
const api_factory_1 = require("./api-factory");
const Exceptions = __importStar(require("./exceptions"));
const dicekeys_recipe_1 = require("./dicekeys-recipe");
const to_name_map_1 = require("./to-name-map");
const encodings_1 = require("./encodings");
const api_calls_1 = require("./api-calls");
exports.UrlRequestMetadataParameterNames = (0, to_name_map_1.toFieldNameMap)("respondTo", "authToken");
exports.UrlApiMetaCommand = (0, to_name_map_1.toNameMap)([
    "getAuthToken"
]);
const GetAuthTokenResponseParameterNames = (0, to_name_map_1.toFieldNameMap)("authToken");
class UrlApi {
    constructor(requestUrlString, respondToUrl, transmitRequest) {
        this.requestUrlString = requestUrlString;
        this.respondToUrl = respondToUrl;
        this.transmitRequest = transmitRequest;
        this.pendingPromisesForRequestResponseUrls = new Map();
        this.getAuthToken = (forceReload = false) => __awaiter(this, void 0, void 0, function* () {
            if (forceReload || !this.authToken) {
                const requestUrl = new URL(this.requestUrlString);
                const requestId = (0, api_factory_1.generateRequestId)();
                requestUrl.searchParams.set(api_calls_1.RequestMetadataParameterNames.requestId, requestId);
                requestUrl.searchParams.set(exports.UrlRequestMetadataParameterNames.respondTo, this.respondToUrl);
                requestUrl.searchParams.set(api_calls_1.RequestCommandParameterNames.command, exports.UrlApiMetaCommand.getAuthToken);
                return new Promise((resolve, reject) => {
                    this.pendingPromisesForRequestResponseUrls.set(requestId, url => {
                        const newAuthToken = url.searchParams.get(GetAuthTokenResponseParameterNames.authToken);
                        if (newAuthToken != null) {
                            this.authToken = newAuthToken;
                            resolve(newAuthToken);
                        }
                        else {
                            reject(new Exceptions.ClientNotAuthorizedException());
                        }
                    });
                    this.transmitRequest(requestUrl);
                });
            }
            else {
                return this.authToken;
            }
        });
        this.call = (request) => __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c, _d;
            const requestUrl = new URL(this.requestUrlString);
            const marshallString = (field, value) => requestUrl.searchParams.set(field, value);
            const marshallBoolean = (field, value) => requestUrl.searchParams.set(field, value ? "true" : "false");
            const requestId = (0, api_factory_1.generateRequestId)();
            marshallString(api_calls_1.RequestMetadataParameterNames.requestId, requestId);
            marshallString(exports.UrlRequestMetadataParameterNames.respondTo, this.respondToUrl);
            marshallString(api_calls_1.RequestCommandParameterNames.command, request.command);
            const recipe = "packagedSealedMessageJson" in request ?
                (_a = JSON.parse(request.packagedSealedMessageJson).recipe) !== null && _a !== void 0 ? _a : "" :
                (_b = request.recipe) !== null && _b !== void 0 ? _b : "";
            if (typeof recipe !== "string") {
                throw new Exceptions.MissingParameter(`Missing parameter recipe`);
            }
            if ("recipe" in request && request.recipe != null) {
                marshallString(api_calls_1.RecipeFunctionParameterNames.recipe, request.recipe);
            }
            if ("recipeMayBeModified" in request && request.recipeMayBeModified != null) {
                marshallBoolean(api_calls_1.RecipeFunctionParameterNames.recipeMayBeModified, request.recipeMayBeModified);
            }
            const { requireAuthenticationHandshake } = (0, dicekeys_recipe_1.Recipe)(recipe);
            if (requireAuthenticationHandshake) {
                const authToken = yield this.getAuthToken();
                requestUrl.searchParams.set(exports.UrlRequestMetadataParameterNames.authToken, authToken);
            }
            switch (request.command) {
                case api_calls_1.Command.generateSignature:
                    marshallString(api_calls_1.GenerateSignatureParameterNames.message, (0, encodings_1.urlSafeBase64Encode)(request.message));
                    break;
                case api_calls_1.Command.getPassword:
                case api_calls_1.Command.getSealingKey:
                case api_calls_1.Command.getSecret:
                case api_calls_1.Command.getSignatureVerificationKey:
                case api_calls_1.Command.getSigningKey:
                case api_calls_1.Command.getSymmetricKey:
                case api_calls_1.Command.getUnsealingKey:
                    break;
                case api_calls_1.Command.sealWithSymmetricKey:
                    marshallString(api_calls_1.SealWithSymmetricKeyParameterNames.plaintext, (0, encodings_1.urlSafeBase64Encode)(request.plaintext));
                    if (request.unsealingInstructions != null) {
                        marshallString(api_calls_1.SealWithSymmetricKeyParameterNames.unsealingInstructions, request.unsealingInstructions);
                    }
                    break;
                case api_calls_1.Command.unsealWithSymmetricKey:
                case api_calls_1.Command.unsealWithUnsealingKey:
                    marshallString(api_calls_1.UnsealWithUnsealingKeyParameterNames.packagedSealedMessageJson, request.packagedSealedMessageJson);
            }
            const urlPromise = new Promise((resolve, _reject) => this.pendingPromisesForRequestResponseUrls.set(requestId, resolve));
            this.transmitRequest(requestUrl);
            const url = yield urlPromise;
            const exception = url.searchParams.get(api_calls_1.ExceptionResponseParameterNames.exception);
            if (typeof exception === "string") {
                const message = (_c = url.searchParams.get(api_calls_1.ExceptionResponseParameterNames.message)) !== null && _c !== void 0 ? _c : undefined;
                const stack = (_d = url.searchParams.get(api_calls_1.ExceptionResponseParameterNames.stack)) !== null && _d !== void 0 ? _d : undefined;
                throw Exceptions.restoreException(exception, message, stack);
            }
            //    const fromJson = <T, U>(json: string, f: (t: T) => U) => f(JSON.parse(json) as T);
            const required = (parameterName) => {
                var _a;
                return (_a = url.searchParams.get(parameterName)) !== null && _a !== void 0 ? _a : (() => { throw new Exceptions.MissingResponseParameter(parameterName); })();
            };
            switch (request.command) {
                case api_calls_1.Command.generateSignature:
                    return {
                        [api_calls_1.GenerateSignatureSuccessResponseParameterNames.signatureVerificationKeyJson]: required(api_calls_1.GenerateSignatureSuccessResponseParameterNames.signatureVerificationKeyJson),
                        [api_calls_1.GenerateSignatureSuccessResponseParameterNames.signature]: (0, encodings_1.urlSafeBase64Decode)(required(api_calls_1.GenerateSignatureSuccessResponseParameterNames.signature))
                    };
                case api_calls_1.Command.getPassword:
                case api_calls_1.Command.getSealingKey:
                case api_calls_1.Command.getSecret:
                case api_calls_1.Command.getSigningKey:
                case api_calls_1.Command.getSymmetricKey:
                case api_calls_1.Command.getUnsealingKey:
                case api_calls_1.Command.getSignatureVerificationKey:
                case api_calls_1.Command.sealWithSymmetricKey:
                    return {
                        [api_calls_1.SeededCryptoObjectResponseParameterNames[request.command]]: required(api_calls_1.SeededCryptoObjectResponseParameterNames[request.command]),
                    };
                    break;
                case api_calls_1.Command.unsealWithSymmetricKey:
                case api_calls_1.Command.unsealWithUnsealingKey:
                    return { plaintext: (0, encodings_1.urlSafeBase64Decode)(required(api_calls_1.UnsealSuccessResponseParameterNames.plaintext)) };
                default:
                    throw new Error();
            }
        });
        /**
        * Sign a message using a public/private signing key pair derived
        * the user's DiceKey using the JSON-encoded [[SigningKeyRecipe]].
       *
      */
        this.generateSignature = (0, api_factory_1.apiCallFactory)(api_calls_1.Command.generateSignature, this.call);
        /**
        * Derive a password from the user's DiceKey and the JSON encoded
        * [[PasswordRecipe]].
        */
        this.getPassword = (0, api_factory_1.apiCallFactory)(api_calls_1.Command.getPassword, this.call);
        /**
        * Derive a SealingKey from the user's DiceKey and the JSON encoded
        * [[UnsealingKeyRecipe]].
        */
        this.getSealingKey = (0, api_factory_1.apiCallFactory)(api_calls_1.Command.getSealingKey, this.call);
        /**
        * Derive a binary Secret from the user's DiceKey and the JSON encoded
        * [[SecretRecipe]].
        */
        this.getSecret = (0, api_factory_1.apiCallFactory)(api_calls_1.Command.getSecret, this.call);
        /**
        * Derive a SignatureVerificationKey from the user's DiceKey and the JSON encoded
        * [[SigningKeyRecipe]].
        */
        this.getSignatureVerificationKey = (0, api_factory_1.apiCallFactory)(api_calls_1.Command.getSignatureVerificationKey, this.call);
        /**
        * Derive a SigningKey from the user's DiceKey and the JSON encoded
        * [[SigningKeyRecipe]].
        */
        this.getSigningKey = (0, api_factory_1.apiCallFactory)(api_calls_1.Command.getSigningKey, this.call);
        /**
        * Derive a SymmetricKey from the user's DiceKey and the JSON encoded
        * [[SymmetricKeyRecipe]].
        */
        this.getSymmetricKey = (0, api_factory_1.apiCallFactory)(api_calls_1.Command.getSymmetricKey, this.call);
        /**
        * Derive an UnsealingKey from the user's DiceKey and the JSON encoded
        * [[UnsealingKeyRecipe]].
        */
        this.getUnsealingKey = (0, api_factory_1.apiCallFactory)(api_calls_1.Command.getUnsealingKey, this.call);
        /**
        * Seal a message with a SymmetricKey derived from from the user's DiceKey and the JSON encoded
        * [[SymmetricKeyRecipe]].
        */
        this.sealWithSymmetricKey = (0, api_factory_1.apiCallFactory)(api_calls_1.Command.sealWithSymmetricKey, this.call);
        /**
        * Unseal a message sealed with a SymmetricKey derived from from the user's DiceKey and the JSON encoded
        * [[SymmetricKeyRecipe]].
        */
        this.unsealWithSymmetricKey = (0, api_factory_1.apiCallFactory)(api_calls_1.Command.unsealWithSymmetricKey, this.call);
        /**
        * Unseal a message sealed with an UnsealingKey derived from from the user's DiceKey and the JSON encoded
        * [[UnsealingKeyRecipe]].
        */
        this.unsealWithUnsealingKey = (0, api_factory_1.apiCallFactory)(api_calls_1.Command.unsealWithUnsealingKey, this.call);
        /**
         * Activities and Fragments that use this API should implement onActivityResult and
         * and call handleOnActivityResult with the data/intent (third parameter) received.
         * Doing so allows this class to process results returned to the activity/fragment
         * and then call the appropriate callback functions when an API call has either
         * succeeded or failed.
         */
        this.handleResult = (result) => {
            const requestId = result.searchParams.get(api_calls_1.RequestMetadataParameterNames.requestId);
            if (requestId && this.pendingPromisesForRequestResponseUrls.has(requestId)) {
                const resolve = this.pendingPromisesForRequestResponseUrls.get(requestId);
                this.pendingPromisesForRequestResponseUrls.delete(requestId);
                resolve(result);
            }
        };
    }
}
exports.UrlApi = UrlApi;
//# sourceMappingURL=url-api.js.map